import React from 'react';
import { useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { Tabs } from '~/eds/src/components/Tabs/Tabs';
import { Tab } from '~/eds/src/types/Tab';
import { useRouting } from '~/routing/useRouting';

import { DEFAULT_TAB } from '../../../constants';
import { TabValue } from '../../../types';
import { formatUrl } from '../../../utils';
import { ClauseSummaries } from './ClauseSummaries';

export const LeftPane = () => {
  const intl = useIntl();

  const tabs: Tab<TabValue>[] = [
    {
      label: intl.formatMessage({
        id: 'LeftPane.publishedTab',
        defaultMessage: 'Published',
        description: 'Tab label for published clauses',
      }),
      value: 'published',
      panel: <ClauseSummaries />,
    },
    {
      label: intl.formatMessage({
        id: 'LeftPane.reviewTab',
        defaultMessage: 'Review',
        description: 'Tab label for clauses under review',
      }),
      value: 'review',
      panel: <ClauseSummaries />,
    },
    {
      label: intl.formatMessage({
        id: 'LeftPane.aiSuggestedTab',
        defaultMessage: 'AI Suggested',
        description: 'Tab label for AI suggested clauses',
      }),
      value: 'ai-suggested',
      panel: <ClauseSummaries />,
    },
  ];

  const { getSearchParam, navigate } = useRouting();
  const tab = getSearchParam<TabValue>('tab', DEFAULT_TAB);

  const handleUpdateTab = (tabValue: TabValue) => {
    navigate(formatUrl(tabValue));
  };

  return (
    <Box
      flex="none"
      w="25%"
      minW="sidebar.width.s"
      maxW="sidebar.width.m"
      overflowY="auto"
    >
      <Tabs
        enableContentPadding={false}
        onSelectTab={handleUpdateTab}
        selectedTab={tab}
        tabs={tabs}
      />
    </Box>
  );
};
